import React, { useMemo } from "react";
import DataTable from "../_Components/DataTable";
import _ from "lodash";
import Switch from "@mui/material/Switch";
import { Link } from "react-router-dom";
function DataGrid({ data }) {
  const columns = useMemo(
    () => [
      {
        accessor: "id",
        Header: "#",
        minWidth: 50,
      },
      {
        accessor: "type",
        Header: "نوع",
        minWidth: 120,
        Cell: ({ row }) => (
          <div
            className={`text-center d-inline-block rounded-pill px-4 py-1 text-white ${row.original.type === 1 ? "bg-light-pink-1" : row.original.type === 4 ? "bg-light-green-blue-1" : row.original.type === 2 ? "bg-light-orange-1" : "bg-light-green-1 "}`}
          >
            {row.original.strType}
          </div>
        ),
      },
      {
        accessor: "regionId",
        Header: "url",
        minWidth: 120,
        Cell: ({ row }) => {
          const separator =
            _.isEmpty(row.original.amusementGroupUrlName) || _.isEmpty(row.original.regionEnglishName) ? "" : "/";
          if (_.isEmpty(row.original.amusementGroupUrlName) && _.isEmpty(row.original.regionEnglishName)) {
            return "";
          }
          return (
            <p>
              {row.original.regionEnglishName} {separator} {row.original.amusementGroupUrlName}
            </p>
          );
        },
      },
      {
        accessor: "amusementServiceCount",
        Header: "تعداد تفریحات",
        minWidth: 100,
      },
      {
        accessor: "activeAmusementServiceCount",
        Header: "تعداد تفریحات فعال",
        minWidth: 100,
      },
      {
        accessor: (row) => {
          if (row.type === 2 || row.type === 1) {
            return row.h1;
          } else if (row.type === 3) {
            return row.headerContent || "پیش فرض";
          }
        },
        Header: "عنوان",
        minWidth: 120,
      },

      // {
      //   accessor: "content",
      //   Header: "توضیحات",
      //   minWidth: 120,
      //   Cell: ({ row }) => {
      //     const content =
      //       row.original?.content?.length > 100 ? row.original?.content?.slice(0, 30) + "..." : row.original?.content;
      //     return <div className="text-center" dangerouslySetInnerHTML={{ __html: content }} />;
      //   },
      // },

      {
        accessor: "createdPersianTime",
        Header: "زمان ایجاد",
        minWidth: 90,
        maxWidth: 90,
      },
      {
        Header: "وضعیت",
        minWidth: "100px",
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            <Switch
              checked={row.original.status ? true : false}
              value="row.original.active"
              color="primary"
              inputProps={{ "aria-label": "primary checkbox" }}
            />
          </div>
        ),
      },
      {
        Header: "عملیات",
        accessor: "",
        minWidth: 150,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            <Link
              className="btn btn-light-primary btn-sm mr-2 btn-icon"
              title="ویرایش"
              to={`/pageContent/${row.original.id}`}
            >
              <i className="far fa-edit text-small"></i>
            </Link>
          </div>
        ),
      },
    ],
    [],
  );

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data ?? { data: [] }} />
    </div>
  );
}

export default DataGrid;
